import {
    restQuery,
    QueryResult,
    BaseModel,
    restMutation,
    MutationResult,
} from 'vue-apollo-model';
import { BaseDataResponse } from '@/type';
import { handleErrorMessageToast } from '@/common/util';
import { CorporationInfo, EnterpriseInfo, ManagerInfo } from '@/models/qualification';

export interface ChangeMailLimit {
    left?: number;
    limit?: number;
    operation?: string;
    range?: number;
    unit?: string;
}

export interface ProfileUserInfoType {
    changeMailLimit: ChangeMailLimit;
    corporationInfo: CorporationInfo;
    enterpriseInfo: EnterpriseInfo;
    mail: string;
    managerInfos: ManagerInfo[];
}
export type ProfileUserInfoResponse = BaseDataResponse<ProfileUserInfoType>;

export class ProfileModel extends BaseModel {
    @restQuery<ProfileModel>({
        url: '/account/user/info',
        method: 'get',
        variables() {
            return this.operationToken
                ? { operation_token: this.operationToken }
                : {};
        },
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    profileUserInfoQuery!: QueryResult<ProfileUserInfoResponse>;

    operationToken?: string;

    get isLoading() {
        return !!this.profileUserInfoQuery.loading;
    }

    key = Date.now();

    reset() {
        this.key = Date.now();
    }

    get profileInfo() {
        return this.profileUserInfoQuery.data.data || {};
    }

    @restMutation<ProfileModel>({
        url: '/account/user/send/mail/code',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    getMailCodeMutation!: MutationResult<any, any>;

    async getMailCode(params: any): Promise<string | undefined> {
        await this.getMailCodeMutation.mutate(params);
        if (this.getMailCodeMutation.data.result !== 1) {
            handleErrorMessageToast(this.getMailCodeMutation.data.error_msg);
            return;
        }
    }

    @restMutation<ProfileModel>({
        url: '/account/user/verify/mail/code',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    submitMailAuthMutation!: MutationResult<any, any>;

    async submitMailAuth(params: any) {
        await this.submitMailAuthMutation.mutate(params);
        return this.submitMailAuthMutation.data;
    }

    @restMutation<ProfileModel>({
        url: '/account/user/phone/verify',
        method: 'get',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    getPhoneCaptchaMutation!: MutationResult<any, any>;

    async getPhoneCaptcha(phone: string) {
        await this.getPhoneCaptchaMutation.mutate({ phone });
        return this.getPhoneCaptchaMutation.data;
    }

    // 更新管理员信息
    @restMutation<ProfileModel>({
        url: '/account/user/update/manager',
        method: 'post',
        variables: (p) => p,
        headers: {
            'content-type': 'application/x-www-form-urlencoded',
        },
    })
    updateManagerMutation!: MutationResult<any, any>;

    async updateManager(params: any) {
        await this.updateManagerMutation.mutate(params);
    }
}

